'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useEffect, useRef, useState } from 'react';
import { noop } from 'lodash';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
export default function RadioButtons({ name = 'radio-group', value: valueProp = undefined, defaultValue, items = [], onChange = noop, onInit = noop, component = {} }) {
    const [value, setValue] = useState(defaultValue || valueProp);
    const itemsRef = useRef(items);
    const handleChange = ({ target }) => {
        setValue(target.value);
        onChange(target.value);
    };
    useEffect(() => {
        value && onInit(value);
    }, []);
    const RadioItem = ({ item = {}, component: rc = {} }) => {
        const hasComponent = rc?.key === item.value;
        return (_jsxs(Fragment, { children: [_jsx(FormControlLabel, { value: item.value, control: _jsx(Radio, {}), label: item.label }), hasComponent && rc.component] }, item.label));
    };
    return (_jsx(_Fragment, { children: _jsx(RadioGroup, { name: name, value: value, onChange: handleChange, children: itemsRef.current?.map((item) => (_jsx(RadioItem, { item: item, component: component }, item.value))) }) }));
}
